import styled, { css } from "styled-components";
import {device} from './device';

type PanelBodyProps = {
  emptyGuests?:boolean;
}

type FormFieldWrapperProps = {
  hasError?: boolean;
};

export const MainWrapper = styled.div`
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
`;

export const PanelContainer = styled.div`
  border: 1px solid #dee2db;
  border-radius: 7px 7px 0px 0px;
  margin-bottom: 45px;
`;

export const PanelHeader = styled.div`
  padding: 19px 0px 15px;
  width: 97%;
  margin: 0 auto;
  border-bottom: 1px solid #dee2eb;
`;

export const PanelHeaderTitle = styled.span`
  margin-left: 15px;
  font-size: 18px;
  font-family: "Poppins-Bold";
`;

export const PanelBody = styled.div`
 ${(props: PanelBodyProps) =>
    props.emptyGuests &&
    css`
     min-height: 200px;
    `}
`;

export const ListContainer = styled.div`
  padding: 0 10px;
`;
export const ListItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0 10px 15px;
  border-bottom: 1px solid #dee2eb;
  align-items: center;
  
`;

export const ErrorMessage = styled.div`
  font-family: inherit;
  text-align: right;
  color: #f84b7a;
  font-size: 12px;

  position: absolute;
  right: 0;
  bottom: -20px;
`;

export const FormFieldWrapper = styled.div<FormFieldWrapperProps>`
  display: inline-block;
  text-align: center;
  margin: 0 0 20px 0;
  position: relative;

  ${props =>
    props.hasError &&
    css`
      margin-bottom: 3px;
    `};

  @media (max-width: ${device.tablet}) {
    width: 100%;
  }
`;
